import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { notify } from '../utils/notify';
import '../styles/fmp.css';

const ConfigContasOmie = () => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();

  // Estados
  const [dadosCliente, setDadosCliente] = useState(null);
  const [contas, setContas] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [mensagem, setMensagem] = useState({ tipo: '', texto: '' });

  // Ponte para toasts (react-toastify): dispara o toast conforme o tipo da mensagem
  useEffect(() => {
    if (!mensagem.texto) return;
    if (mensagem.tipo === 'success') notify.sucesso(mensagem.texto);
    else if (mensagem.tipo === 'warning') notify.aviso(mensagem.texto);
    else if (mensagem.tipo === 'danger') notify.erro(mensagem.texto);
    else notify.info(mensagem.texto);
  }, [mensagem]);

  const [modalNovaConta, setModalNovaConta] = useState(false);
  const [modalImportarOmie, setModalImportarOmie] = useState(false);
  const [contasOmie, setContasOmie] = useState([]);
  const [carregandoOmie, setCarregandoOmie] = useState(false);
  const [contasSelecionadas, setContasSelecionadas] = useState([]);

  // Estados para Nova Conta
  const [novaConta, setNovaConta] = useState({
    codigo: '',
    nome: '',
    nome_curto: '',
    tipo: 'Conta Corrente',
    categoria: 'Conta Corrente',
    cor: '#00205b',
    icone: 'fas fa-university',
    posicao: 'Sim',
    total_disponivel: 'Sim',
    fluxo_caixa: 'Sim',
    codigo_conta_azul: ''
  });

  useEffect(() => {
    if (cliente_id) {
      carregarDadosCliente();
      carregarContas();
    }
  }, [cliente_id]);

  // ========================================
  // CARREGAR DADOS DO CLIENTE
  // ========================================
  const carregarDadosCliente = async () => {
    const token = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/cliente-bpo/${cliente_id}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        setDadosCliente(response.data.cliente);
      }
    } catch (error) {
      console.error('Erro ao carregar cliente:', error);
      if (error.response?.status === 401) {
        navigate('/login');
      }
    }
  };

  // ========================================
  // CARREGAR CONTAS
  // ========================================
  const carregarContas = async () => {
    setCarregando(true);
    const token = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/contas-cliente/${cliente_id}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        setContas(response.data.contas);
        console.log('Contas carregadas:', response.data.contas);
      }
    } catch (error) {
      console.error('Erro ao carregar contas:', error);
      mostrarMensagem('danger', 'Erro ao carregar contas');
    } finally {
      setCarregando(false);
    }
  };

  // ========================================
  // MOSTRAR MENSAGEM
  // ========================================
  const mostrarMensagem = (tipo, texto) => {
    setMensagem({ tipo, texto });
    setTimeout(() => setMensagem({ tipo: '', texto: '' }), 5000);
  };

  // ========================================
  // BUSCAR CONTAS DA OMIE
  // ========================================
  const buscarContasOmie = async () => {
    setCarregandoOmie(true);
    setContasOmie([]);
    const token = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/buscar-contas-omie/${cliente_id}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        setContasOmie(response.data.contas);
        setModalImportarOmie(true);
        mostrarMensagem('success', `${response.data.total} contas encontradas na Omie!`);
      }
    } catch (error) {
      console.error('Erro ao buscar contas Omie:', error);
      const errorMsg = error.response?.data?.erro || 'Erro ao buscar contas da Omie';
      mostrarMensagem('danger', errorMsg);
    } finally {
      setCarregandoOmie(false);
    }
  };

  // ========================================
  // BUSCAR CONTAS DO CONTA AZUL
  // ========================================
  const buscarContasContaAzul = async () => {
    setCarregandoOmie(true);
    setContasOmie([]);
    const token = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/buscar-contas-conta-azul/${cliente_id}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        setContasOmie(response.data.contas);
        setModalImportarOmie(true);
        mostrarMensagem('success', `${response.data.total} contas encontradas no Conta Azul!`);
      }
    } catch (error) {
      console.error('Erro ao buscar contas Conta Azul:', error);
      const errorMsg = error.response?.data?.erro || 'Erro ao buscar contas do Conta Azul';
      mostrarMensagem('danger', errorMsg);
    } finally {
      setCarregandoOmie(false);
    }
  };

  // ========================================
  // IMPORTAR CONTAS SELECIONADAS
  // ========================================
  const importarContasSelecionadas = async () => {
    if (contasSelecionadas.length === 0) {
      mostrarMensagem('warning', 'Selecione pelo menos uma conta para importar');
      return;
    }

    const token = localStorage.getItem('access');
    let importadas = 0;
    let erros = 0;

    for (const contaId of contasSelecionadas) {
      // Buscar conta por codigo_conta_azul ou codigo
      const conta = contasOmie.find(c => 
        (c.codigo_conta_azul && c.codigo_conta_azul === contaId) || 
        c.codigo === contaId
      );
      
      if (!conta) continue;

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE}/api/criar-conta/`,
          { ...conta, nome_curto: conta.nome, id_cliente: cliente_id },
          { headers: { 'Authorization': `Bearer ${token}` } }
        );

        if (response.data.success) {
          importadas++;
        } else {
          erros++;
        }
      } catch (error) {
        console.error(`Erro ao importar ${conta.nome}:`, error);
        erros++;
      }
    }

    if (importadas > 0) {
      mostrarMensagem('success', `${importadas} conta(s) importada(s) com sucesso!`);
      carregarContas();
      setModalImportarOmie(false);
      setContasSelecionadas([]);
    }

    if (erros > 0) {
      mostrarMensagem('warning', `${erros} conta(s) não foram importadas (podem já existir)`);
    }
  };

  // ========================================
  // TOGGLE SELEÇÃO DE CONTA
  // ========================================
  const toggleSelecaoConta = (identificador) => {
    setContasSelecionadas(prev => 
      prev.includes(identificador) 
        ? prev.filter(c => c !== identificador)
        : [...prev, identificador]
    );
  };

  // ========================================
  // SELECIONAR/DESSELECIONAR TODAS
  // ========================================
  const toggleTodasContas = () => {
    if (contasSelecionadas.length === contasOmie.length) {
      setContasSelecionadas([]);
    } else {
      // Usar codigo_conta_azul se existir, senão usar codigo
      setContasSelecionadas(contasOmie.map(c => c.codigo_conta_azul || c.codigo));
    }
  };

  // ========================================
  // ATUALIZAR CONFIGURAÇÃO DA CONTA
  // ========================================
  const atualizarConfiguracao = async (contaCodigo, campo, valor) => {
    const token = localStorage.getItem('access');

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE}/api/atualizar-conta/${contaCodigo}/`,
        { campo, valor, id_cliente: cliente_id },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        mostrarMensagem('success', 'Configuração atualizada!');
        
        // Atualizar localmente
        setContas(contas.map(c => 
          c.codigo === contaCodigo ? { ...c, [campo]: valor } : c
        ));
      }
    } catch (error) {
      console.error('Erro ao atualizar:', error);
      mostrarMensagem('danger', 'Erro ao atualizar configuração');
    }
  };

  // ========================================
  // CRIAR NOVA CONTA
  // ========================================
  const criarNovaConta = async () => {
    const token = localStorage.getItem('access');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/criar-conta/`,
        { ...novaConta, id_cliente: cliente_id },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        mostrarMensagem('success', 'Conta criada com sucesso!');
        setModalNovaConta(false);
        carregarContas();
        
        // Resetar form
        setNovaConta({
          codigo: '',
          nome: '',
          nome_curto: '',
          tipo: 'Conta Corrente',
          categoria: 'Conta Corrente',
          cor: '#00205b',
          icone: 'fas fa-university',
          posicao: 'Sim',
          total_disponivel: 'Sim',
          fluxo_caixa: 'Sim',
          codigo_conta_azul: ''
        });
      }
    } catch (error) {
      console.error('Erro ao criar conta:', error);
      const errorMsg = error.response?.data?.erro || 'Erro ao criar conta';
      mostrarMensagem('danger', errorMsg);
    }
  };

  // ========================================
  // DELETAR CONTA
  // ========================================
  const deletarConta = async (contaCodigo) => {
    if (!window.confirm('Tem certeza que deseja deletar esta conta?')) return;

    const token = localStorage.getItem('access');

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE}/api/deletar-conta/${contaCodigo}/${cliente_id}/`,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        mostrarMensagem('success', 'Conta deletada com sucesso!');
        carregarContas();
      }
    } catch (error) {
      console.error('Erro ao deletar conta:', error);
      mostrarMensagem('danger', 'Erro ao deletar conta');
    }
  };

  // ========================================
  // OPÇÕES DE SELECT
  // ========================================
  const TIPOS_CONTA = [
    'Conta Corrente',
    'Cartão de Crédito',
    'investimento',
    'Caixa',
    'Outros'
  ];

  const CATEGORIAS = [
    'Conta Corrente',
    'Cartão de Crédito',
    'investimento',
    'Caixa',
    'Outros'
  ];

  const ICONES = [
    'fas fa-university',
    'fas fa-credit-card',
    'fas fa-chart-line',
    'fas fa-wallet',
    'fas fa-money-bill-wave',
    'fas fa-piggy-bank',
    'fas fa-coins'
  ];

  // Apenas as cores da identidade FMP (layout.md) — usadas como cor da conta nos gráficos
  const CORES = [
    '#00205b', // Navy (primária)
    '#00215f', // Navy profundo
    '#0043c2', // Azul vivo
    '#00b5cc', // Ciano (secundária)
    '#03bfd7', // Ciano claro
    '#f1be48', // Dourado (acento)
    '#9063cd', // Roxo
    '#32d263', // Verde
    '#1fa971', // Verde (produto)
    '#dc3545'  // Vermelho (semântico)
  ];

  if (!dadosCliente) {
    return (
      <div className="container-fluid mt-5">
        <div className="text-center">
          <div className="spinner-border text-primary"></div>
          <p className="mt-3 text-muted">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4 fmp-brand-page">
      {/* HEADER */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-start">
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-cogs header-icon me-3"></i>
                    <h2 className="titulo-pagina m-0">Configuração de Contas</h2>
                  </div>
                  <p className="mb-1 opacity-75">
                    <i className="fas fa-building me-2"></i>
                    {dadosCliente.nome}
                  </p>
                  <p className="mb-0 opacity-75">
                    <i className="fas fa-file-alt me-2"></i>
                    CNPJ: {dadosCliente.cnpj}
                    {dadosCliente.sistema && (
                      <span className="badge bg-white text-dark ms-3">
                        <i className="fas fa-server me-1"></i>
                        Sistema: {dadosCliente.sistema}
                      </span>
                    )}
                  </p>
                </div>
                
                <div className="d-flex gap-2">
                  {/* BOTÃO DE CONSULTAR/REFRESH - SEMPRE VISÍVEL */}
                  {/* <button 
                    className="btn btn-success"
                    onClick={carregarContas}
                    disabled={carregando}
                    title="Atualizar lista de contas"
                  >
                    {carregando ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Carregando...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sync-alt me-2"></i>
                        Consultar Contas
                      </>
                    )}
                  </button> */}

                  {/* BOTÃO IMPORTAR DA OMIE - SÓ APARECE SE SISTEMA = OMIE */}
                  {dadosCliente?.sistema === 'omie' && (
                    <button 
                      className="btn btn-info"
                      onClick={buscarContasOmie}
                      disabled={carregandoOmie}
                    >
                      {carregandoOmie ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Buscando...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-cloud-download-alt me-2"></i>
                          Importar da Omie
                        </>
                      )}
                    </button>
                  )}

                  {/* BOTÃO IMPORTAR DO CONTA AZUL - SÓ APARECE SE SISTEMA = CONTA_AZUL */}
                  {dadosCliente?.sistema === 'conta_azul' && (
                    <button 
                      className="btn btn-info"
                      onClick={buscarContasContaAzul}
                      disabled={carregandoOmie}
                    >
                      {carregandoOmie ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Buscando...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-cloud-download-alt me-2"></i>
                          Importar do Conta Azul
                        </>
                      )}
                    </button>
                  )}
                  
                  {/* <button 
                    className="btn btn-light"
                    onClick={() => navigate(`/dashboard-cliente/${cliente_id}`)}
                  >
                    <i className="fas fa-arrow-left me-2"></i>
                    Voltar ao Dashboard
                  </button>
                   */}
                  <button 
                    className="btn btn-warning"
                    onClick={() => setModalNovaConta(true)}
                  >
                    <i className="fas fa-plus me-2"></i>
                    Nova Conta Manual
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mensagens agora são exibidas como toast (react-toastify) */}

      {/* BRIEFING DAS COLUNAS */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="card border-0 shadow-sm border-start border-4 border-primary">
            <div className="card-body py-3">
              <h6 className="fw-bold text-primary mb-2">
                <i className="fas fa-info-circle me-2"></i>
                Como funcionam as configurações de exibição
              </h6>
              <div className="row g-2">
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <span className="badge bg-primary mt-1" style={{minWidth: '20px'}}>P</span>
                    <div>
                      <strong className="d-block">Posição Financeira</strong>
                      <small className="text-muted">Contas marcadas como <strong>Sim</strong> serão consideradas para o envio da Posição Financeira</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <span className="badge bg-success mt-1" style={{minWidth: '20px'}}>T</span>
                    <div>
                      <strong className="d-block">Total Disponível</strong>
                      <small className="text-muted">Contas marcadas como <strong>Sim</strong> serão consideradas como saldo de conta corrente no Dashboard principal</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-2">
                    <span className="badge bg-warning text-dark mt-1" style={{minWidth: '20px'}}>F</span>
                    <div>
                      <strong className="d-block">Fluxo de Caixa</strong>
                      <small className="text-muted">Contas marcadas como <strong>Sim</strong> serão consideradas para o Fluxo de Caixa diário</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TABELA DE CONTAS */}
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-light d-flex justify-content-between align-items-center">
              <div>
                <i className="fas fa-list me-2 text-primary"></i>
                <span className="fw-bold">Contas Cadastradas</span>
              </div>
              <span className="badge bg-primary">{contas.length} contas</span>
            </div>
            <div className="card-body">
              {carregando ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary"></div>
                  <p className="mt-3 text-muted">Carregando contas...</p>
                </div>
              ) : contas.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        <th style={{width: '10%'}}>Código</th>
                        <th style={{width: '18%'}}>Nome</th>
                        <th style={{width: '12%'}}>Nome Curto</th>
                        <th style={{width: '12%'}}>Tipo</th>
                        <th style={{width: '8%'}} className="text-center">Cor</th>
                        <th style={{width: '8%'}} className="text-center">Ícone</th>
                        <th style={{width: '8%'}} className="text-center">
                          Posição
                          <i
                            className="fas fa-info-circle ms-1 text-muted"
                            style={{fontSize: '12px', cursor: 'help'}}
                            title="Contas marcadas como Sim serão consideradas para o envio da Posição Financeira"
                          ></i>
                        </th>
                        <th style={{width: '8%'}} className="text-center">
                          Total Disp.
                          <i
                            className="fas fa-info-circle ms-1 text-muted"
                            style={{fontSize: '12px', cursor: 'help'}}
                            title="Contas marcadas como Sim serão consideradas como saldo de conta corrente no Dashboard principal"
                          ></i>
                        </th>
                        <th style={{width: '8%'}} className="text-center">
                          Fluxo Caixa
                          <i
                            className="fas fa-info-circle ms-1 text-muted"
                            style={{fontSize: '12px', cursor: 'help'}}
                            title="Contas marcadas como Sim serão consideradas para o Fluxo de Caixa diário"
                          ></i>
                        </th>
                        <th style={{width: '8%'}} className="text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contas.map((conta, index) => {
                        // Criar ID único: codigo_conta_azul ou codigo ou nome
                        const contaId = conta.codigo_conta_azul || conta.codigo || `${conta.nome}_${index}`;
                        
                        return (
                          <tr key={`conta-${index}`}>
                            <td>
                              <small className="text-muted">
                                {conta.codigo || conta.codigo_conta_azul?.substring(0, 8) || 'N/A'}
                              </small>
                            </td>
                            <td>
                              <strong>{conta.nome}</strong>
                              <br />
                              <small className="text-muted">{conta.categoria}</small>
                            </td>
                            <td>{conta.nome_curto}</td>
                            <td>
                              <span className="badge bg-info">
                                {conta.tipo}
                              </span>
                            </td>
                            <td className="text-center">
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                <span
                                  style={{
                                    width: '24px',
                                    height: '24px',
                                    backgroundColor: conta.cor,
                                    borderRadius: '4px',
                                    border: '2px solid rgba(0,0,0,0.15)',
                                    flex: 'none'
                                  }}
                                ></span>
                                <select
                                  className="form-select form-select-sm"
                                  value={conta.cor || ''}
                                  onChange={(e) => atualizarConfiguracao(contaId, 'cor', e.target.value)}
                                  title="Escolha uma cor do layout"
                                  style={{minWidth: '92px'}}
                                >
                                  {conta.cor && !CORES.includes(conta.cor) && (
                                    <option value={conta.cor}>{conta.cor} (atual)</option>
                                  )}
                                  {CORES.map((cor) => (
                                    <option key={cor} value={cor} style={{backgroundColor: cor, color: '#fff'}}>
                                      {cor}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </td>
                            <td className="text-center">
                              <i 
                                className={conta.icone} 
                                style={{fontSize: '20px', color: conta.cor}}
                              ></i>
                            </td>
                            <td className="text-center">
                              <select 
                                className="form-select form-select-sm"
                                value={conta.posicao || 'Não'}
                                onChange={(e) => atualizarConfiguracao(contaId, 'posicao', e.target.value)}
                              >
                                <option value="Sim">Sim</option>
                                <option value="Não">Não</option>
                              </select>
                            </td>
                            <td className="text-center">
                              <select 
                                className="form-select form-select-sm"
                                value={conta.total_disponivel || 'Não'}
                                onChange={(e) => atualizarConfiguracao(contaId, 'total_disponivel', e.target.value)}
                              >
                                <option value="Sim">Sim</option>
                                <option value="Não">Não</option>
                              </select>
                            </td>
                            <td className="text-center">
                              <select 
                                className="form-select form-select-sm"
                                value={conta.fluxo_caixa || 'Não'}
                                onChange={(e) => atualizarConfiguracao(contaId, 'fluxo_caixa', e.target.value)}
                              >
                                <option value="Sim">Sim</option>
                                <option value="Não">Não</option>
                              </select>
                            </td>
                            <td className="text-center">
                              <button 
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deletarConta(contaId)}
                                title="Deletar conta"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-5 text-muted">
                  <i className="fas fa-inbox fa-4x mb-3"></i>
                  <h5 className="text-muted">Nenhuma conta cadastrada</h5>
                  <p className="text-muted">
                    {dadosCliente?.sistema === 'Omie' 
                      ? 'Clique em "Importar da Omie" ou "Nova Conta Manual" para adicionar contas.'
                      : dadosCliente?.sistema === 'conta_azul'
                      ? 'Clique em "Importar do Conta Azul" ou "Nova Conta Manual" para adicionar contas.'
                      : 'Clique em "Nova Conta Manual" para adicionar a primeira conta.'}
                  </p>
                  <div className="d-flex gap-2 justify-content-center mt-3">
                    {dadosCliente?.sistema === 'Omie' && (
                      <button 
                        className="btn btn-info"
                        onClick={buscarContasOmie}
                      >
                        <i className="fas fa-cloud-download-alt me-2"></i>
                        Importar da Omie
                      </button>
                    )}
                    {dadosCliente?.sistema === 'conta_azul' && (
                      <button 
                        className="btn btn-info"
                        onClick={buscarContasContaAzul}
                      >
                        <i className="fas fa-cloud-download-alt me-2"></i>
                        Importar do Conta Azul
                      </button>
                    )}
                    <button 
                      className="btn btn-primary"
                      onClick={() => setModalNovaConta(true)}
                    >
                      <i className="fas fa-plus me-2"></i>
                      Adicionar Primeira Conta
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* MODAL NOVA CONTA */}
      {modalNovaConta && (
        <div className="modal fade show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-plus me-2"></i>
                  Nova Conta Bancária
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalNovaConta(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-hashtag me-2 text-muted"></i>
                      Código da Conta *
                    </label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={novaConta.codigo}
                      onChange={(e) => setNovaConta({...novaConta, codigo: e.target.value})}
                      placeholder="Ex: 1361214022"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-building me-2 text-muted"></i>
                      Nome Completo *
                    </label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={novaConta.nome}
                      onChange={(e) => setNovaConta({...novaConta, nome: e.target.value, nome_curto: e.target.value})}
                      placeholder="Ex: Banco Itaú Conta Corrente"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-tag me-2 text-muted"></i>
                      Nome Curto *
                    </label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={novaConta.nome_curto}
                      onChange={(e) => setNovaConta({...novaConta, nome_curto: e.target.value})}
                      placeholder="Ex: Itaú"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-folder me-2 text-muted"></i>
                      Tipo de Conta
                    </label>
                    <select 
                      className="form-select"
                      value={novaConta.tipo}
                      onChange={(e) => setNovaConta({...novaConta, tipo: e.target.value})}
                    >
                      {TIPOS_CONTA.map(tipo => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-list me-2 text-muted"></i>
                      Categoria
                    </label>
                    <select 
                      className="form-select"
                      value={novaConta.categoria}
                      onChange={(e) => setNovaConta({...novaConta, categoria: e.target.value})}
                    >
                      {CATEGORIAS.map(cat => (
                        <option key={cat} value={cat}>{cat}</option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label fw-bold">
                      <i className="fas fa-palette me-2 text-muted"></i>
                      Cor
                    </label>
                    <select 
                      className="form-select"
                      value={novaConta.cor}
                      onChange={(e) => setNovaConta({...novaConta, cor: e.target.value})}
                    >
                      {CORES.map(cor => (
                        <option key={cor} value={cor} style={{backgroundColor: cor, color: 'white'}}>
                          {cor}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label fw-bold">
                      <i className="fas fa-icons me-2 text-muted"></i>
                      Ícone
                    </label>
                    <select 
                      className="form-select"
                      value={novaConta.icone}
                      onChange={(e) => setNovaConta({...novaConta, icone: e.target.value})}
                    >
                      {ICONES.map(icone => (
                        <option key={icone} value={icone}>
                          {icone.split(' ')[1].replace('fa-', '')}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="col-12">
                    <hr />
                    <h6 className="text-muted mb-3">
                      <i className="fas fa-toggle-on me-2"></i>
                      Configurações de Exibição
                    </h6>
                  </div>
                  
                  <div className="col-md-4">
                    <label className="form-label fw-bold">Posição Financeira</label>
                    <select 
                      className="form-select"
                      value={novaConta.posicao}
                      onChange={(e) => setNovaConta({...novaConta, posicao: e.target.value})}
                    >
                      <option value="Sim">Sim</option>
                      <option value="Não">Não</option>
                    </select>
                    <small className="text-muted">Exibir na Posição Financeira</small>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-bold">Total Disponível</label>
                    <select 
                      className="form-select"
                      value={novaConta.total_disponivel}
                      onChange={(e) => setNovaConta({...novaConta, total_disponivel: e.target.value})}
                    >
                      <option value="Sim">Sim</option>
                      <option value="Não">Não</option>
                    </select>
                    <small className="text-muted">Incluir no Total Disponível</small>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-bold">Fluxo de Caixa</label>
                    <select 
                      className="form-select"
                      value={novaConta.fluxo_caixa}
                      onChange={(e) => setNovaConta({...novaConta, fluxo_caixa: e.target.value})}
                    >
                      <option value="Sim">Sim</option>
                      <option value="Não">Não</option>
                    </select>
                    <small className="text-muted">Exibir no Fluxo de Caixa</small>
                  </div>
                  
                  <div className="col-12">
                    <label className="form-label fw-bold">
                      <i className="fas fa-link me-2 text-muted"></i>
                      Código Conta Azul (UUID)
                    </label>
                    <input 
                      type="text" 
                      className="form-control"
                      value={novaConta.codigo_conta_azul}
                      onChange={(e) => setNovaConta({...novaConta, codigo_conta_azul: e.target.value})}
                      placeholder="Ex: b06c50fb-5e0c-440a-96b0-0da649853b9a"
                    />
                    <small className="text-muted">Opcional - Para integração com Conta Azul</small>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setModalNovaConta(false)}
                >
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary"
                  onClick={criarNovaConta}
                  disabled={!novaConta.codigo || !novaConta.nome || !novaConta.nome_curto}
                >
                  <i className="fas fa-save me-2"></i>
                  Salvar Conta
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL IMPORTAR CONTAS OMIE/CONTA AZUL */}
      {modalImportarOmie && (
        <div className="modal fade show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog" style={{maxWidth: '95%', margin: '1.75rem auto'}}>
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-cloud-download-alt me-2"></i>
                  Importar Contas {dadosCliente?.sistema === 'omie' ? 'da omie' : 'do Conta Azul'} ({contasOmie.length} encontradas)
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setModalImportarOmie(false);
                    setContasSelecionadas([]);
                  }}
                ></button>
              </div>
              <div className="modal-body" style={{maxHeight: '70vh', overflowY: 'auto'}}>
                {contasOmie.length === 0 ? (
                  <div className="text-center py-5">
                    <i className="fas fa-inbox fa-4x text-muted mb-3"></i>
                    <h5 className="text-muted">Nenhuma conta encontrada</h5>
                  </div>
                ) : (
                  <>
                    <div className="alert alert-info mb-3">
                      <i className="fas fa-info-circle me-2"></i>
                      Selecione as contas que deseja importar. Contas já cadastradas não serão duplicadas.
                    </div>
                    
                    <div className="table-responsive">
                      <table className="table table-hover align-middle">
                        <thead className="table-light sticky-top">
                          <tr>
                            <th style={{width: '50px'}} className="text-center">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={contasSelecionadas.length === contasOmie.length && contasOmie.length > 0}
                                onChange={toggleTodasContas}
                              />
                            </th>
                            <th style={{width: '100px'}}>Código</th>
                            <th style={{width: '300px'}}>Nome</th>
                            <th style={{width: '150px'}}>Tipo</th>
                            <th style={{width: '100px'}}>Banco</th>
                            <th style={{width: '100px'}}>Agência</th>
                            <th style={{width: '150px'}}>Conta</th>
                            <th style={{width: '150px'}} className="text-end">Saldo Inicial</th>
                            <th style={{width: '100px'}}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {contasOmie.map((conta, index) => {
                            // Criar identificador único: codigo_conta_azul ou codigo
                            const contaId = conta.codigo_conta_azul || conta.codigo;
                            
                            return (
                              <tr 
                                key={index}
                                className={contasSelecionadas.includes(contaId) ? 'table-primary' : ''}
                                style={{cursor: 'pointer'}}
                                onClick={() => toggleSelecaoConta(contaId)}
                              >
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={contasSelecionadas.includes(contaId)}
                                    onChange={() => toggleSelecaoConta(contaId)}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </td>
                                <td>
                                  <code className="text-muted">{conta.codigo_conta_azul || conta.codigo}</code>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    <i className={conta.icone} style={{color: conta.cor, fontSize: '18px'}}></i>
                                    <div>
                                      <strong>{conta.nome}</strong>
                                      <br />
                                      <small className="text-muted">{conta.nome_curto}</small>
                                    </div>
                                  </div>
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                  <select
                                    className="form-select form-select-sm"
                                    value={conta.tipo || 'Conta Corrente'}
                                    onChange={(e) => {
                                      setContasOmie(prev => prev.map((c, i) =>
                                        i === index ? { ...c, tipo: e.target.value, categoria: e.target.value } : c
                                      ));
                                    }}
                                  >
                                    <option value="Conta Corrente">Conta Corrente</option>
                                    <option value="investimento">Investimento</option>
                                    <option value="Cartão de Crédito">Cartão de Crédito</option>
                                    <option value="Outros">Outros</option>
                                  </select>
                                </td>
                                <td>{conta.codigo_banco || '-'}</td>
                                <td>{conta.agencia || '-'}</td>
                                <td>{conta.numero_conta || '-'}</td>
                                <td className="text-end">
                                  {conta.saldo_inicial !== undefined ? (
                                    <strong className={conta.saldo_inicial >= 0 ? 'text-success' : 'text-danger'}>
                                      R$ {conta.saldo_inicial.toLocaleString('pt-BR', {minimumFractionDigits: 2})}
                                    </strong>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td>
                                <td>
                                  {conta.inativo || (conta.ativo !== undefined && !conta.ativo) ? (
                                    <span className="badge bg-danger">Inativa</span>
                                  ) : (
                                    <span className="badge bg-success">Ativa</span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <div className="me-auto">
                  <span className="text-muted">
                    <i className="fas fa-check-square me-2"></i>
                    {contasSelecionadas.length} conta(s) selecionada(s)
                  </span>
                </div>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setModalImportarOmie(false);
                    setContasSelecionadas([]);
                  }}
                >
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-primary"
                  onClick={importarContasSelecionadas}
                  disabled={contasSelecionadas.length === 0}
                >
                  <i className="fas fa-download me-2"></i>
                  Importar {contasSelecionadas.length > 0 ? `(${contasSelecionadas.length})` : ''}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigContasOmie;